import { createStore } from '../../util/createStore';
var useStore = createStore({
    isSidebarOpen: false,
}).useStore;
export function usePage() {
    var _a = useStore(), state = _a[0], setState = _a[1];
    return {
        isSidebarOpen: state.isSidebarOpen,
        toggleIsSidebarOpen: function (value) {
            setState(function (state) {
                state.isSidebarOpen = value !== null && value !== void 0 ? value : !value;
            });
        },
    };
}
